var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [(_vm.reading != null) ? _c('ul', {
    staticClass: "nav nav-tabs sup-tabs",
    staticStyle: {
      "margin-bottom": "7px"
    }
  }, [_c('li', {
    class: {
      'active': _vm.subAnteprima
    },
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.subAnteprima = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('preview', null)))])]), _vm._v(" "), _c('li', {
    class: {
      'active': !_vm.subAnteprima
    },
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.subAnteprima = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('documents list', null)))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "doc-container",
    staticStyle: {
      "width": "100%",
      "text-align": "right",
      "overflow-y": "auto"
    },
    style: ({
      'max-height': _vm.maxh ? _vm.maxh + 'px' : 'unset'
    }),
    attrs: {
      "id": "scroll-thumb"
    }
  }, [(_vm.reading == null || !_vm.subAnteprima) ? _c('div', [_vm._l((_vm.documents), function(doc) {
    return (_vm.ready && _vm.documents && _vm.documents.length > 0) ? _c('div', {
      staticClass: "thumbnail",
      class: {
        'active': _vm.reading != null && doc.na == _vm.reading.na
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.read(doc)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('div', {
      staticClass: "caption"
    }, [_c('button', {
      staticClass: "btn btn-sm"
    }, [_c('i', {
      class: _vm.$root.icons.download,
      staticStyle: {
        "margin-left": "0px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.download(doc)
        }
      }
    })]), _vm._v(" "), (_vm.$Behaviors.useClientDocumentType) ? _c('p', [_vm._v(_vm._s(doc.documentType))]) : _c('p', [_vm._v(_vm._s(doc.filename + '.pdf'))])]), _vm._v(" "), _c('div', {
      staticClass: "embed-responsive embed-responsive-4by3 bg-cover",
      staticStyle: {
        "width": "100%"
      },
      style: (_vm.getTabDocStyle(doc))
    })])]) : _vm._e()
  }), _vm._v(" "), (_vm.ready && _vm.documents.length == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "10px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('no document available', null)))])]) : _vm._e()], 2) : _c('div', [_vm._l((_vm.previews), function(p) {
    return _c('div', {
      staticClass: "thumbnail",
      class: {
        'active': _vm.readingPage == p.page
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.readPage(p.page)
        }
      }
    }, [_c('div', {
      staticClass: "caption"
    }, [_c('p', [_vm._v(_vm._s(p.page))])]), _vm._v(" "), _c('div', {
      staticClass: "embed-responsive embed-responsive-4by3 bg-cover",
      staticStyle: {
        "width": "100%"
      },
      style: (_vm.getStyle(p))
    })])])
  }), _vm._v(" "), (!_vm.previews || _vm.previews.length == 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "10px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('no preview available', null)))])]) : _vm._e()], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17ac4b63","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu-sup-components/Documenti.vue
// module id = 1446
// module chunks = 1